// utils/validators.js
export const validators = {
  isValidEmail: (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  },

  isValidOtp: (otp) => {
    return otp && otp.length === 6 && /^\d{6}$/.test(otp);
  }
};

